export default __webpack_public_path__ + "static/media/categoryOther.27ff9f4e.jpg";